import {Dayjs} from 'dayjs';
import {JsonMappers, json} from '../../../core/data-source/json.mapper';
import {ReportedLoadingOrderRecord} from './reported-loading-order.record';

export class LoadingReportRecord {
    @json({
        skip: true
    })
    id: number;

    @json()
    vehicleName: string;

    @json()
    driverName: string;

    @json()
    dcName: string;

    @json({mapper: JsonMappers.Dayjs})
    startDate: Dayjs;

    @json()
    status: string;

    @json({
        jsonName: 'number'
    })
    runNumber: number;

    @json()
    updatedBy: string;

    @json({mapper: JsonMappers.Dayjs})
    updatedDate: Dayjs;

    @json(JsonMappers.ArrayOf(() => ReportedLoadingOrderRecord))
    orders: ReportedLoadingOrderRecord[];

    @json({skip: true})
    options: any;
}
